import { LayoutDashboard, TrendingUp, FileSignature, Megaphone, Globe, Users, Home, Contact, GraduationCap, ClipboardList, Plug, DoorOpen } from "lucide-react";

export const ROLE_LABELS = {
  admin: "Administrator",
  sales_manager: "Sales Manager",
  contracts_team: "Contracts Team",
  marketing_manager: "Marketing Manager",
  agent: "Agent",
};

export const ROLE_OPTIONS = [
  { value: "admin", label: "Administrator" },
  { value: "sales_manager", label: "Sales Manager" },
  { value: "contracts_team", label: "Contracts Team" },
  { value: "marketing_manager", label: "Marketing Manager" },
  { value: "agent", label: "Agent" },
];

// key must match backend ROLE_TOOLS entries
export const TOOLS = [
  { key: "sales", name: "Sales Tracker", path: "/sales", icon: TrendingUp, desc: "Deal tracker: contracts, commissions & company net" },
  { key: "transactions", name: "Transaction Manager", path: "/transactions", icon: FileSignature, desc: "Contract-to-close: key dates, workflows & deadlines" },
  { key: "listings", name: "Property Websites", path: "/listings", icon: Megaphone, desc: "Property marketing sites, leads & analytics" },
  { key: "seo", name: "Agent Pages", path: "/seo", icon: Globe, desc: "AI-optimized agent landing page & blog" },
  { key: "office_procedures", name: "Office Procedures", path: "/procedures", icon: ClipboardList, desc: "Company SOPs & office procedure documents" },
  { key: "training", name: "Training", path: "/training", icon: GraduationCap, desc: "Agent training courses, videos & progress" },
  { key: "users", name: "User Management", path: "/users", icon: Users, desc: "Manage team & access levels" },
];

export const DASHBOARD_ITEM = { key: "dashboard", name: "Dashboard", path: "/", icon: LayoutDashboard };
export const INTEGRATIONS_ITEM = { key: "integrations", name: "API & Integrations", path: "/integrations", icon: Plug };
export const CLIENT_PORTAL_ITEM = { key: "client_portal", name: "Client Portal", path: "/client-portal", icon: DoorOpen };
export const PROPERTIES_ITEM = { key: "properties", name: "Properties", path: "/properties", icon: Home };
export const PEOPLE_ITEM = { key: "people", name: "People", path: "/people", icon: Contact };
